/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Label } from '../models/Label';
import type { Paging_RecordDetail_ } from '../models/Paging_RecordDetail_';
import type { RecordDetail } from '../models/RecordDetail';
import type { RecordInsight } from '../models/RecordInsight';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ClaudeTemporaryService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * List Record
   * `dialogs`는 제외하고 내려감.
   *
   * `owner_id` > 0 인 경우에만 필터링이 동작합니다.
   *
   * optional query parameter의 조합은, 아래와 같이 동작합니다.
   * - (`user_id`, `owner_id`)를 함께 사용하는 경우, 500을 응답합니다; 함께 사용하는 경우가 없다고 가정했기 때문입니다.
   * - (`user_id`, `team_id`)를 함께 사용하는 경우, and로 동작합니다.
   * - (`owner_id`, `team_id`)를 함께 사용하는 경우, and로 동작합니다.
   *
   * - `query`와 (`user_id` 또는 `owner_id` 또는 `team_id`)의 조합으로 사용하는 경우, \
   * (`user_id` 또는 `owner_id` 또는 `team_id`)로 필터링되지 않을 수 있습니다. \
   * 이것까지 필터링하고 싶다면, callabo-server에서 이 API 로직을 수정해야합니다.
   * @param query 검색 키워드
   * @param labelIds 레이블 id 리스트
   * @param labelFilterCondition 레이블 필터링 조건
   * @param order 레코드 정렬 기준 (내림차순)
   * @param nextToken pagination token
   * @param userId record.user_id
   * @param ownerId record.owner_id
   * @param teamId record.team_id 또는 record.accessible_team_id
   * @returns Paging_RecordDetail_ Successful Response
   * @throws ApiError
   */
  public listRecordTapiWorkspaceRtzrRecordGet(
    query?: string | null,
    labelIds?: Array<number> | null,
    labelFilterCondition: 'and' | 'or' = 'and',
    order: 'id' | 'rec_date' = 'id',
    nextToken?: string | null,
    userId?: number | null,
    ownerId?: number | null,
    teamId?: number | null
  ): CancelablePromise<Paging_RecordDetail_> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/tapi/workspace/rtzr/record',
      query: {
        query: query,
        label_ids: labelIds,
        label_filter_condition: labelFilterCondition,
        order: order,
        next_token: nextToken,
        user_id: userId,
        owner_id: ownerId,
        team_id: teamId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Get Record
   * @param id
   * @param query 검색어: 막걸리 보내주세요
   * @returns RecordDetail Successful Response
   * @throws ApiError
   */
  public getRecordTapiWorkspaceRtzrRecordIdGet(
    id: number,
    query?: string | null
  ): CancelablePromise<RecordDetail> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/tapi/workspace/rtzr/record/{id}',
      path: {
        id: id,
      },
      query: {
        query: query,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Get Insight
   * @param id
   * @returns RecordInsight Successful Response
   * @throws ApiError
   */
  public getInsightTapiWorkspaceRtzrRecordIdInsightGet(
    id: number
  ): CancelablePromise<Array<RecordInsight>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/tapi/workspace/rtzr/record/{id}/insight',
      path: {
        id: id,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * List Label
   * @returns Label Successful Response
   * @throws ApiError
   */
  public listLabelTapiWorkspaceRtzrLabelGet(): CancelablePromise<Array<Label>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/tapi/workspace/rtzr/label',
    });
  }
}
